import React, { useEffect, useState, useRef } from 'react';
import { Play, Calendar, Clock, Search } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
import { Card } from '../components/ui/Card';
import { season1Episodes, SPOTIFY_SHOW_URL } from '../data/season1Episodes';
// Real Episode Data from Buzzsprout / Spotify
const episodes = season1Episodes;
export function PodcastsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const buzzsproutRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (buzzsproutRef.current) {
      buzzsproutRef.current.innerHTML = '';
      const container = document.createElement('div');
      container.id = 'buzzsprout-large-player';
      buzzsproutRef.current.appendChild(container);
      const script = document.createElement('script');
      script.src = 'https://www.buzzsprout.com/2590035.js?container_id=buzzsprout-large-player&player=large';
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      buzzsproutRef.current.appendChild(script);
    }
    return () => {
      if (buzzsproutRef.current) {
        buzzsproutRef.current.innerHTML = '';
      }
    };
  }, []);
  const filteredEpisodes = episodes.filter(ep => ep.title.toLowerCase().includes(searchTerm.toLowerCase()) || ep.guest.toLowerCase().includes(searchTerm.toLowerCase()));
  return <PageTransition data-id="element-704" data-mp="2gf3wnpnp8lzh">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-705" data-mp="3433n0oh3madj">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-706" data-mp="343dbu8qeqbhn">
          {/* Header */}
          <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-707" data-mp="3835fc70y1rg5">
            <div data-id="element-708" data-mp="2uc8y1ccgwwoe">
              <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-709" data-mp="2ucs4nwwo3yn4">
                All Episodes
              </h1>
              <p className="text-white/80 text-lg" data-id="element-710" data-mp="3n1pkltdepjcp">
                Listen to the latest conversations.
              </p>
            </div>

            {/* Search Bar */}
            <div className="relative w-full md:w-72" data-id="element-711" data-mp="3ruironwcl3ry">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-712" data-mp="5jackqls4513">
                <Search className="h-5 w-5 text-white/40" data-id="element-713" data-mp="kz1kcjqzoha" />
              </div>
              <input type="text" placeholder="Search episodes..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-dark-500 rounded-md leading-5 bg-dark-800 text-white placeholder-white/40 focus:outline-none focus:bg-dark-700 focus:border-gold-500 transition duration-150 ease-in-out sm:text-sm" data-id="element-714" data-mp="3rppdiyl7pyi5" />
            </div>
          </div>

          {/* Buzzsprout Player */}
          <div className="mb-12 bg-dark-800 rounded-2xl p-6 border border-dark-600" data-id="element-715" data-mp="341z1ur7equuh">
            <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-716" data-mp="2z0i3b2cebkh2">
              Listen to All Episodes
            </h2>
            <div ref={buzzsproutRef} className="w-full" data-id="element-717" data-mp="2v0rhld1q7uje" />
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-718" data-mp="1ahe0wtoel3st">
            {filteredEpisodes.map(ep => <Card key={ep.id} className="flex flex-col h-full bg-dark-700 border-dark-600" data-id="element-719" data-mp="1eld82lnsmq9i">
                <div className="p-6 flex flex-col h-full" data-id="element-720" data-mp="1ognd7i9hndri">
                  <div className="flex justify-between items-start mb-4" data-id="element-721" data-mp="qty5crs3u6xq">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gold-500/10 text-gold-500" data-id="element-722" data-mp="qvra21j5qh33">
                      {ep.category}
                    </span>
                    <span className="text-white/40 text-xs font-mono" data-id="element-723" data-mp="10q14dorntpgg">
                      EP {ep.id}
                    </span>
                  </div>

                  <h3 className="text-xl font-serif font-bold text-white mb-1 line-clamp-2 hover:text-gold-400 transition-colors cursor-pointer" data-id="element-724" data-mp="84887y0vd92n">
                    {ep.title}
                  </h3>
                  <p className="text-sm text-gold-500 mb-4 font-medium" data-id="element-725" data-mp="2eqxh9nc30lub">
                    with {ep.guest}
                  </p>

                  <p className="text-white/70 text-sm mb-6 flex-grow line-clamp-3" data-id="element-726" data-mp="2aryjcmorppcd">
                    {ep.description}
                  </p>

                  <div className="flex items-center justify-between pt-4 border-t border-dark-600 mt-auto" data-id="element-727" data-mp="2jr219nc77ypa">
                    <div className="flex items-center space-x-4 text-xs text-white/50" data-id="element-728" data-mp="2yf6kqtj2se94">
                      <span className="flex items-center" data-id="element-729" data-mp="2tgvawiss63qw">
                        <Calendar className="w-3 h-3 mr-1" data-id="element-730" data-mp="2tgbrexnhf7ar" /> {ep.date}
                      </span>
                      <span className="flex items-center" data-id="element-731" data-mp="37fl7lxbou1eq">
                        <Clock className="w-3 h-3 mr-1" data-id="element-732" data-mp="32h1jprdjafjq" /> {ep.duration}
                      </span>
                    </div>
                    <a href={ep.spotifyUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-gold-500 flex items-center justify-center text-dark-900 hover:scale-110 transition-transform shadow-lg shadow-gold-500/20" data-id="element-733" data-mp="1d2vehht58w8e">
                      <Play className="w-4 h-4 fill-current ml-0.5" data-id="element-734" data-mp="3aytv5kurmmmp" />
                    </a>
                  </div>
                </div>
              </Card>)}
          </div>

          {filteredEpisodes.length === 0 && <div className="text-center py-20" data-id="element-735" data-mp="30zcslcat8ouy">
              <p className="text-white/60 text-lg" data-id="element-736" data-mp="35z7hxbext6dw">
                No episodes found matching your search.
              </p>
            </div>}

          {/* Listen on Spotify Banner */}
          <div className="mt-12 bg-dark-800 rounded-xl p-8 text-center border border-dark-600" data-id="element-737" data-mp="2w11j52ofggd9">
            <h3 className="text-2xl font-serif font-bold text-white mb-3" data-id="element-738" data-mp="q833oyxee6a6">
              Listen on Spotify
            </h3>
            <p className="text-white/60 mb-6" data-id="element-739" data-mp="ua6f5nk2havg">
              Follow 3 Doves Podcast on Spotify to get notified when new
              episodes drop.
            </p>
            <a href={SPOTIFY_SHOW_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-[#1DB954] text-white font-medium rounded-full hover:bg-[#1ed760] transition-colors shadow-lg" data-id="element-740" data-mp="2348rkvyemlmn">
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-741" data-mp="1p96n8d97h4by">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" data-id="element-742" data-mp="2hwkcrqakqxm1" />
              </svg>
              Follow on Spotify
            </a>
          </div>
        </div>
      </div>
    </PageTransition>;
}